// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".get-rates-btn-container[data-v-71d8b52f]{display:grid;justify-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}sup[data-v-71d8b52f]{color:red;font-size:14px}", ""]);
// Exports
module.exports = exports;
